export const notices = [
  {
    id: 1,
    title: '코리아케어러스 앱 서비스 오픈 안내',
    date: '2026.06.10',
    content: '코리아케어러스 앱 서비스가 정식 오픈되었습니다. 더 나은 간병 매칭 서비스를 제공하겠습니다.',
    category: '공지',
    isNew: true,
  },
  {
    id: 2,
    title: '2026년 6월 서비스 이용약관 개정 안내',
    date: '2026.06.15',
    content: '서비스 이용약관 및 개인정보 처리방침이 일부 개정되었습니다. 변경된 내용을 확인해주세요.',
    category: '약관',
    isNew: true,
  },
  {
    id: 3,
    title: '간병인 자격증 등록 시 주의사항',
    date: '2026.06.08',
    content: '간병인 등록 시 유효한 자격증 정보를 정확히 입력해주세요. 허위 정보 등록 시 서비스 이용이 제한될 수 있습니다.',
    category: '안내',
    isNew: false,
  },
  {
    id: 4,
    title: '여름철 간병 시 주의사항 안내',
    date: '2026.06.05',
    content: '무더위 속 건강한 간병을 위해 환기, 수분섭취, 체온 관리에 유의해주세요.',
    category: '안내',
    isNew: false,
  },
  {
    id: 5,
    title: '고객센터 운영시간 변경 안내',
    date: '2026.06.01',
    content: '고객센터 운영시간이 평일 09:00 ~ 18:00로 변경되었습니다.',
    category: '공지',
    isNew: false,
  },
];